/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 소유자 타입 (MEMBER: 회원 소유, EXPERT: 코치 소유, EXPERT_WORKSPACE: 센터 소유)
 */
export type WorkoutTemplateOwnerType = 'MEMBER' | 'EXPERT' | 'EXPERT_WORKSPACE';

export const WorkoutTemplateOwnerType = {
    Member: 'MEMBER' as WorkoutTemplateOwnerType,
    Expert: 'EXPERT' as WorkoutTemplateOwnerType,
    ExpertWorkspace: 'EXPERT_WORKSPACE' as WorkoutTemplateOwnerType
};

